// extracted by mini-css-extract-plugin
module.exports = {"list":"practiceSearchList_list__3At0e","empty":"practiceSearchList_empty__35LFh","item":"practiceSearchList_item__2yRxP"};